export * from "./ResultItem";
export * from "./ResultItem.styled";
